import { Check } from "lucide-react";

/**
 * Mandatory consent + privacy acknowledgement for enquiry & purchase forms.
 * Controlled checkbox — parent owns `checked` state and gates submit until true.
 */
export const ConsentCheckbox = ({ checked, onChange, testId = "consent-checkbox" }) => (
  <label
    className="flex items-start gap-3 cursor-pointer select-none rounded-xl border border-[var(--line)] bg-white/60 px-4 py-3 hover:border-[var(--ink)] transition-colors"
    data-testid={`${testId}-label`}
  >
    <span
      className={`mt-0.5 shrink-0 w-5 h-5 rounded-md border-2 flex items-center justify-center transition-colors ${
        checked
          ? "bg-[var(--ink)] border-[var(--ink)]"
          : "bg-white border-[var(--line)]"
      }`}
      aria-hidden="true"
    >
      {checked && <Check size={13} strokeWidth={3} className="text-[var(--paper)]" />}
    </span>
    <input
      type="checkbox"
      data-testid={testId}
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      className="sr-only"
    />
    <span className="text-[12px] leading-relaxed text-[var(--ocean)]">
      I acknowledge that The Ditch Collective provides relocation support, information,
      referrals, and general guidance only. The Ditch Collective does not provide legal,
      migration, taxation, financial, accounting, lending, or property advice. I understand
      that relocation outcomes, employment outcomes, rental approvals, and third-party
      services cannot be guaranteed.{" "}
      <a
        href="/disclaimer"
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-[var(--ink)]"
        onClick={(e) => e.stopPropagation()}
      >
        Disclaimer
      </a>
      {" · "}
      <a
        href="/privacy"
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-[var(--ink)]"
        onClick={(e) => e.stopPropagation()}
      >
        Privacy
      </a>
      {" · "}
      <a
        href="/refund"
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-[var(--ink)]"
        onClick={(e) => e.stopPropagation()}
      >
        Refund Policy
      </a>
    </span>
  </label>
);
